import { FC, useContext, useState } from 'react';

import {
  AlertIcon,
  BottomIcon,
  ICommonIconProps,
  Tooltip,
  TopIcon,
} from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { IComment } from 'types';

import s from './CollapsibleItem.module.scss';

interface ICollapsibleItemProps {
  title: string;
  Icon?: FC<ICommonIconProps>;
  color?: 'orange' | 'blue';
  defaultState?: boolean;
  comment?: Pick<IComment, 'text' | 'is_important'> | null;
}

export const CollapsibleItem: FC<ICollapsibleItemProps> = ({
  title,
  Icon,
  color,
  children,
  defaultState = false,
  comment,
}) => {
  const [isOpen, setIsOpen] = useState(defaultState);
  const { t } = useContext(LocalizationContext);
  return (
    <div className={s.container}>
      <div className={s.header} onClick={() => setIsOpen(!isOpen)}>
        {Icon && (
          <div className={cn(s['icon-container'], color && s[color])}>
            <Icon size="s" />
          </div>
        )}
        <span className={s.title}>{title}</span>
        <div className={s.icon_block}>
          {comment?.is_important && (
            <div className={s.important}>
              <Tooltip content={t('important')} contentClassName={s.tooltip}>
                <AlertIcon color="warning" />
              </Tooltip>
            </div>
          )}
          {isOpen ? <TopIcon /> : <BottomIcon />}
        </div>
      </div>
      {isOpen && <div className={s.content}>{children}</div>}
    </div>
  );
};
